/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Equipment_WordsInputs */

const en_us2_search_field_equipment_words = /** @type {(inputs: Search_Field_Equipment_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dumbbells bench barbell equipment plates band machine`)
};

const pt_br2_search_field_equipment_words = /** @type {(inputs: Search_Field_Equipment_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`halteres banco barra equipamento anilhas elastico maquina`)
};

const es_419_search_field_equipment_words = /** @type {(inputs: Search_Field_Equipment_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mancuernas banco barra equipo discos banda liga maquina`)
};

const pt_pt2_search_field_equipment_words = /** @type {(inputs: Search_Field_Equipment_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`halteres banco barra equipamento discos elastico maquina`)
};

const fr_fr2_search_field_equipment_words = /** @type {(inputs: Search_Field_Equipment_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`halteres banc barre equipement disques elastique machine`)
};

const de_de2_search_field_equipment_words = /** @type {(inputs: Search_Field_Equipment_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kurzhanteln hantelbank langhantel ausstattung geräte scheiben band maschine`)
};

const it_it2_search_field_equipment_words = /** @type {(inputs: Search_Field_Equipment_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`manubri panca bilanciere attrezzatura dischi elastico macchina`)
};

/**
* | output |
* | --- |
* | "dumbbells bench barbell equipment plates band machine" |
*
* @param {Search_Field_Equipment_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_equipment_words = /** @type {((inputs?: Search_Field_Equipment_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Equipment_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_equipment_words(inputs)
	if (locale === "es-419") return es_419_search_field_equipment_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_equipment_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_equipment_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_equipment_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_equipment_words(inputs)
	return en_us2_search_field_equipment_words(inputs)
});
export { search_field_equipment_words as "search.field_equipment_words" }